<script>
import blob from '../components/blob.vue';
import fadeInUp from '../components/animations/FadeInUp.vue';
import imageItem from '../components/ImageItem.vue';
import linesUp from '../components/animations/LinesUp.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        blob,
        fadeInUp,
        imageItem,
        linesUp,
        wordsUp,
        magnetic
    },

    data() {
        return {
            active: 1,
            total: 0
        };
    },

    computed: {
        blobTrack() {
            return this.total * 100 + 20 - 100;
        }
    },

    mounted() {
        ScrollTrigger.create({
            trigger: this.$refs.container,
            start: 'top top',
            end: 'bottom bottom',
            pin: this.$refs.pinWrapper
        });

        gsap.utils.toArray('[data-section]').forEach((section, i) => {
            this.total = this.total + 1;

            ScrollTrigger.create({
                trigger: section,
                start: 'top center',
                onToggle: self => (this.active = i)
            });
        });

        this.parallax();
    },

    methods: {
        parallax() {
            gsap.fromTo(
                this.$refs.blob,
                { yPercent: -10 },
                { yPercent: this.blobTrack, ease: 'none', scrollTrigger: { trigger: this.$refs.container, scrub: 1 } }
            );
        }
    }
};
</script>
